import { render, staticRenderFns } from "./Base--SideButtons.vue?vue&type=template&id=df8503d4&"
import script from "./Base--SideButtons.vue?vue&type=script&lang=js&"
export * from "./Base--SideButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports